import { PerfChannel } from './models/perf-suggestion.model';

export const SLOW_HTTP_MS = 2000;
export const SLOW_NAVIGATION_MS = 2000;

/** Max number of recent HTTP samples kept for the advisor, so it can't leak. */
export const HTTP_HISTORY_LIMIT = 200;

/** Same GET started this close to another one is treated as a duplicate. */
export const DUPLICATE_WINDOW_MS = 5000;

/** Requests starting within this gap of the previous one ending are chained. */
export const WATERFALL_GAP_MS = 50;
export const WATERFALL_MIN_CHAIN = 3;
export const WATERFALL_LOOKBACK_MS = 10000;

/**
 * After a navigation ends, pages usually start loading their own data. Wait
 * this long for those requests to begin, then up to SETTLE_MAX_WAIT_MS for
 * the in-flight ones to finish before judging the page load.
 */
export const SETTLE_GRACE_MS = 300;
export const SETTLE_MAX_WAIT_MS = 5000;

export const SMALL_PAYLOAD_BYTES = 50 * 1024;
export const LARGE_PAYLOAD_BYTES = 500 * 1024;

/** Share of a navigation's duration spent waiting on HTTP to call it blocked. */
export const NAVIGATION_HTTP_BOUND_RATIO = 0.6;
export const CHATTY_NAVIGATION_REQUESTS = 10;

export const HTTP_ERROR_STATUS_FROM = 400;

export function isSlow(channel: PerfChannel, durationMs: number): boolean {
  const threshold =
    channel === PerfChannel.NAV ? SLOW_NAVIGATION_MS : SLOW_HTTP_MS;
  return durationMs > threshold;
}
